import { Button, MenuItem } from '@material-ui/core';
import 'Core/components/TermsAndConditions/LegalDocument.sass';
import { LegalDocument as LegalDocumentDto } from 'Core/models/LegalDocument';
import React, { useState } from 'react';
import Modal from 'Shared/components/Modal';
import OutlinedSelect from 'Shared/components/OutlinedSelect';

type MobileLegalDocumentModalProps = {
  documents: LegalDocumentDto[];
  selectedLegalDocumentId?: string;
  onChange: (docId: string) => void;
  open: boolean;
  onClose: () => void;
};

const MobileLegalDocumentModal = (props: MobileLegalDocumentModalProps) => {
  const { open, onChange, selectedLegalDocumentId, documents, onClose } = props;
  const [legalDocumentId, setLegalDocumentId] = useState<string | undefined>(selectedLegalDocumentId);

  return (
    <Modal open={open} title="Select Legal Terms" onClose={onClose}>
      <div className="legal-mobile-modal__content">
        <OutlinedSelect
          label="Legal Document"
          className="legal-mobile-modal__legal-document-select"
          value={legalDocumentId}
          onChange={e => setLegalDocumentId(e.target.value)}
        >
          {documents.map(doc => (
            <MenuItem key={`legal-mobile-document_${doc.id}`} value={doc.id!}>{doc.legalDocumentType ?.name}</MenuItem>
          ))}
        </OutlinedSelect>
        <Button
          color="primary"
          fullWidth
          variant="contained"
          disabled={!legalDocumentId}
          onClick={() => {
            if (legalDocumentId) {
              onChange(legalDocumentId);
              onClose();
            }
          }}
        >
          Apply
        </Button>
      </div>
    </Modal>
  );
};

export default MobileLegalDocumentModal;
